import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${space['space-1200']} ${space['space-600']} ${space['space-600']};
  gap: ${space['space-600']};
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.tight};
  color: ${semantic.text.primary};
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const Item = styled.li`
  margin: 0;
  padding: 0;
`;

export const ItemButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space['space-400']};
  width: 100%;
  padding: ${space['space-200']};
  background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : 'transparent')};
  border: none;
  border-radius: ${size.radius['radius-md']};
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const Thumbnail = styled.div`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  border-radius: ${size.radius['radius-xs']};
  overflow: hidden;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ThumbnailImage = styled(EntityImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const ItemLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const LanguageSelectorButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  width: 100%;
  margin-top: ${space['space-400']};
  padding: ${space['space-300']} ${space['space-200']};
  background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : 'transparent')};
  border: 0;
  border-radius: 0;
  cursor: pointer;
  text-align: left;
  color: ${semantic.text.secondary};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
  }
`;

export const LanguageSelectorLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
`;
